import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash.debounce';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import imgDefault from '../../assets/img/image_default_paket.jpg';
import { Products as Product } from '../../Module_cms/Offers_And_Promotions/Domain/Model/Products';
interface CustomPickListProps {
  data: Product[];                             // Data paginada del source
  pageSize?: number;                           // Tamaño de página
  sourceSearchValue: string;                   // Texto de búsqueda del source
  onSourceSearchChange: (value: string) => void;
  sourcePage: number;                          // Página actual del source
  onSourcePageChange: (page: number) => void;
  sourceTotalCount: number;                    // Total de items del source (para paginación)
  onChange?: (selected: number[], deleted: number[]) => void;    // Callback para enviar target al padre
  listObtained: Product[];
}

export const CustomPickList: React.FC<CustomPickListProps> = ({
  data,
  pageSize = 5,
  sourceSearchValue,
  onSourceSearchChange,
  sourcePage,
  onSourcePageChange,
  sourceTotalCount,
  onChange,
  listObtained
}) => {
  const [target, setTarget] = useState<Product[]>([]);
  const [selectedSource, setSelectedSource] = useState<number[]>([]);
  const [selectedTarget, setSelectedTarget] = useState<number[]>([]);
  const [delectedTarget, setDelectedTarget] = useState<number[]>([]);
  const [targetSearch, setTargetSearch] = useState('');
  const [targetPage, setTargetPage] = useState(1);
  const [inputValue, setInputValue] = useState(sourceSearchValue);

  const debouncedSearch = useCallback (
    debounce((searchValue: string) => {
      onSourceSearchChange(searchValue);
    }, 500),
    [onSourceSearchChange]
  );

  function onloadlistObtained() {
    if(listObtained.length>0) {
      setTarget(listObtained);
      console.log("onloadlistObtained", target);
    }
  }

  useEffect(() => {
      onloadlistObtained();
  }, [listObtained]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  useEffect(() => {
    const selectedIds = target.map((item) => item.productId);
    const deletedIds = delectedTarget.map((item) => item);
    onChange?.(selectedIds, deletedIds);
        
  }, [target]);


  const filteredTarget = useMemo(() =>
    target.filter((item) =>
      item.productName?.toLowerCase().includes(targetSearch.toLowerCase())
    ),
    [target, targetSearch]
  );

  const paginatedTarget = useMemo(() => {
    const start = (targetPage - 1) * pageSize;
    return filteredTarget.slice(start, start + pageSize);
  }, [filteredTarget, targetPage, pageSize]);

  const handleSourceSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value); // Actualización inmediata del input
    debouncedSearch(value); // Búsqueda con debounce
  };

 const moveToTarget = () => {
  const toMove = data.filter((item) =>
    selectedSource.includes(item.productId) &&
    !target.some((t) => t.productId === item.productId) // evitar duplicados
  );

  if (toMove.length === 0) return; // Nada nuevo que mover

  
  const updated = [...target, ...toMove];
  setTarget(updated);

   // Solo enviar los IDs al padre
    const selectedIds = updated.map((item) => item.productId);
    const deletedIds = delectedTarget.map((item) => item);
    onChange?.(selectedIds, deletedIds);

    setSelectedSource([]);
};

  // const moveToSource = () => {
  //   const toMove = target.filter((item) => selectedTarget.includes(item.productId));
  //   setTarget((prev) => {
  //     const updated = prev.filter((item) => !selectedTarget.includes(item.productId));

  //   // Solo enviar los IDs al padre
  //   const selectedIds = updated.map((item) => item.productId);
  //   onChange?.(selectedIds);

  //     return updated;
  //   });
  //   setSelectedTarget([]);
  // };


// const removeFromTarget = () => {
//   setTarget((prev) => {
//     const updated = prev.filter(item => !selectedTarget.selected.includes(item.productId));

//     // Notificar solo los IDs al padre
//     const selectedIds = updated.map(item => item.productId);
//     onChange?.(selectedIds);

//     return updated;
//   });

//   setSelectedTarget([]);
// };

// const removeFromTarget = () => {

//   const toMove = target.filter((item) => selectedTarget.includes(item.productId));

//   setTarget((prev) => {
//     const updated = prev.filter((item) => !selectedTarget.includes(item.productId));


//     const selectedIds = updated.map((item) => item.productId);

//     //const de = toMove.map((item)=> item.productId);
//     const deletedIds = toMove.map((item)=> item.productId);
    
//     // Notificar al padre con todos los datos relevantes
//      setDelectedTarget(prev =>[
//       ...prev, ...deletedIds
//      ]);

//      onChange?.(selectedIds,deletedIds);

//     return updated;
//   });

//   // Limpiar seleccionados (ya los movimos a deleted)
//   setSelectedTarget([]);
// };


const removeFromTarget = () => {
  if (selectedTarget.length === 0) return;

  setTarget((currentTarget) => {
    const itemsToKeep = currentTarget.filter(
      item => !selectedTarget.includes(item.productId)
    );
    
    const itemsToRemove = currentTarget.filter(
      item => selectedTarget.includes(item.productId)
    ).map(item => item.detailListId ?? 0);
    
    //const removedIds = itemsToRemove.map(item => item.productId);
    
    // Actualiza delectedTarget evitando duplicados
    setDelectedTarget(prev => {
      const newIds = itemsToRemove.filter(id => !prev.includes(id));
      return [...prev, ...newIds];
    });
    
    const remainingIds = itemsToKeep.map(item => item.productId);
    onChange?.(remainingIds, delectedTarget);
    
    return itemsToKeep;
  });

  setSelectedTarget([]);
};


const itemTemplate = (item: Product) => {
        return (
            <div className="content-dproduct">
                <img src={`${item.mainImage ? item.mainImage : imgDefault}`} alt={item.productName} />
                <div className="text">
                    <span className='product-name'>{item.productName}</span>
                    <div className=''>
                        <i className="pi pi-tag text-sm"></i>
                        <span>{item.categoryName}</span>
                        {/* <p>detailListId: {item.detailListId}</p> */}
                    </div>
                </div>
                <span className="price"><span>S/</span> {item.salePrice}</span>
            </div>
        );
    };

  return (
    <div className='content-pick-list'>
      {/* Source List */}
      <div className='col-list'>
        <p>Disponibles</p>
        <div className='content-search'>
        <input
         className='input-search'
          type="text"
          placeholder="Buscar..."
          value={inputValue}
          onChange={(e)=>handleSourceSearchChange(e)}
        />
         <FontAwesomeIcon icon={icon({name: 'search'})} />
        </div>
        <ul className='content-items'>
          {data.map((item) => (
            <li key={`source-${item.productId}`}>
              <label className='d-flex'>
                <input
                style={{width: 20}}
                  type="checkbox"
                  checked={selectedSource.includes(item.productId)}
                  onChange={(e) => {
                    const selected = e.target.checked
                      ? [...selectedSource, item.productId]
                      : selectedSource.filter((id) => id !== item.productId);
                    setSelectedSource(selected);
                  }}
                />
                {itemTemplate(item)}
              </label>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '8px' }}>
          <button type='button' className='btn btn-dark' disabled={sourcePage <= 1} onClick={() => onSourcePageChange(sourcePage - 1)}>
            Anterior
          </button>
          <button
            type='button'
            className='btn btn-dark ms-2'
            disabled={sourcePage >= Math.ceil(sourceTotalCount / pageSize)}
            onClick={() => onSourcePageChange(sourcePage + 1)}
          >
            Siguiente
          </button>
        </div>
      </div>

      {/* Control Buttons */}
      <div className='col-btn' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '1rem' }}>
        <button type='button' className='btn btn-dark' onClick={moveToTarget}>&gt;&gt;</button>
        {/* <button onClick={moveToSource}>&lt;&lt;</button> */}
      </div>

      {/* Target List */}
      <div className='col-list'>
        <p>Seleccionados</p>
        <div className='col-lg-12 d-flex'>
          <div className='content-search'>
            <input
              className='input-search'
              type="text"
              placeholder="Buscar..."
              value={targetSearch}
              onChange={(e) => {
                setTargetSearch(e.target.value);
                setTargetPage(1);
              }}
            />
            <FontAwesomeIcon  icon={icon({name: 'search'})} />
          </div>
          <button type='button' className="btn btn-danger ms-2" onClick={removeFromTarget}><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
        </div>
        <ul className='content-items'>
          {paginatedTarget.map((item) => (
            <li key={`target-${item.productId}`}>
              <label className='d-flex'>
                <input
                style={{width: 20}}
                  type="checkbox"
                  checked={selectedTarget.includes(item.productId)}
                  onChange={(e) => {
                    const selected = e.target.checked
                      ? [...selectedTarget, item.productId]
                      : selectedTarget.filter((id) => id !== item.productId);
                     setSelectedTarget(selected);
                  }}
                />
                {itemTemplate(item)}
              </label>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '8px' }}>
          <button type='button' className='btn btn-dark' disabled={targetPage <= 1} onClick={() => setTargetPage(targetPage - 1)}>
            Anterior
          </button>
          <button
            type='button'
            className='btn btn-dark ms-2'
            disabled={targetPage >= Math.ceil(filteredTarget.length / pageSize)}
            onClick={() => setTargetPage(targetPage + 1)} >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};
